import { render, staticRenderFns } from "./PackagesTable.vue?vue&type=template&id=6f67e352&scoped=true&lang=pug&"
import script from "./PackagesTable.vue?vue&type=script&lang=js&"
export * from "./PackagesTable.vue?vue&type=script&lang=js&"
import style0 from "./PackagesTable.vue?vue&type=style&index=0&id=6f67e352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f67e352",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VMenu,VRow,VSkeletonLoader,VSpacer})
